import { cn } from "@/lib/utils";

export const BrandLogo = ({ className = "", size = "md", variant = "default" }) => {
  const sizes = {
    sm: "text-xl",
    md: "text-2xl",
    lg: "text-4xl",
    xl: "text-6xl",
  };
  const baseColor = variant === "onDark" ? "text-white" : "text-ink";
  return (
    <span
      data-testid="grubpe-logo"
      className={cn(
        "font-heading font-extrabold tracking-tight leading-none select-none",
        sizes[size],
        className
      )}
    >
      <span className={baseColor}>grub</span>
      <span className="text-brand">pe</span>
      <span className="text-sun">.</span>
    </span>
  );
};

export default BrandLogo;
